import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {Typography} from "@material-ui/core";
import React from "react";

const Widgets = ({candidates, filterCandidates}) => {

    const commonStyle = {
        width: '100%',
        height: '150%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '12px',
    };

    const boxStyle = {
        width: 'auto',
        height: '50%',
        marginRight:'5%',
        marginLeft:'5%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '12px', backgroundColor: '#FFFFFF',
    }

    const textStyle = {
        width: '100%',
        marginRight:'2%',
        marginLeft:'2%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }

    const typographyStyle= {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        color: 'black'
    }


    return (
        <Grid sx={{marginBottom: "3%"}} container spacing={2} direction={"row"} justifyContent={"flex-start"} alignContent={"center"} data-testid={"widgets"}>
            <Grid item xs={2}>
                <Box
                    data-testid={"widget-box-all"}
                    sx={{...commonStyle, backgroundColor: '#EF685D'}}
                    onClick={() => {filterCandidates("ALL")}}
                >
                    <Grid container spacing={2} direction={"column"} justifyContent={"center"} alignContent={"stretch"}>
                        <Grid item xs={12}>
                            <Box
                                sx={{...boxStyle}}
                            >
                                <Typography variant="h5" component="h5" style={{ alignItems: 'center', display: 'flex',  justifyContent: 'center', color: 'black'}}>
                                    {candidates?.filter(candidate => candidate.status.name !== 'DECLINE').length}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Box sx={{...textStyle}}>
                                <Typography variant="h5" component="h5" style={{color: 'white', alignItems: 'center', justifyContent: 'center'}} >
                                    Active
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Grid item xs={2}>
            <Box
                data-testid={"widget-box-new"}
                sx={{...commonStyle, backgroundColor: '#EFA355'}}
                onClick={() => {filterCandidates("NEW")}}
            >
                <Grid container spacing={2} direction={"column"} justifyContent={"center"} alignContent={"stretch"}>
                    <Grid item xs={12}>
                        <Box
                            sx={{...boxStyle}}
                        >
                            <Typography variant="h5" component="h5" style={{...typographyStyle}}>
                                {candidates?.filter(candidate => candidate.status.name === 'AWAITING_SCORE').length}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{...textStyle}}>
                            <Typography variant="h5" component="h5" style={{color: 'white', alignItems: 'center', justifyContent: 'center'}} >
                                New
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
            <Grid item xs={2}>
        <Box
            data-testid={"widget-box-progress"}
            onClick={() => {filterCandidates("IN_PROGRESS")}}
            sx={{
                ...commonStyle, backgroundColor: '#3795CE'
            }}
        >
            <Grid container spacing={2} direction={"column"} justifyContent={"center"} alignContent={"stretch"}>
                <Grid item xs={12}>
                    <Box
                        sx={{...boxStyle}}
                    >
                        <Typography variant="h5" component="h5" style={{...typographyStyle}}>
                            {candidates?.filter(candidate => candidate.status.name === 'INITIAL_INTERVIEW' || candidate.status.name === 'NOTIFY_MANAGER').length}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{...textStyle}}>
                        <Typography variant="h5" component="h5" style={{color: 'white', alignItems: 'center', justifyContent: 'center'}} >
                            In Progress
                        </Typography>
                    </Box>
                </Grid>
            </Grid>


        </Box>
    </Grid>
            <Grid item xs={2}>
        <Box
            data-testid={"widget-box-short"}
            sx={{...commonStyle, backgroundColor: '#6DD38A'}}
            onClick={() => {filterCandidates("SHORT_LISTED")}}
        >
            <Grid container spacing={2} direction={"column"} justifyContent={"center"} alignContent={"stretch"}>
                <Grid item xs={12}>
                    <Box
                        sx={{...boxStyle}}
                    >
                        <Typography variant="h5" component="h5" style={{...typographyStyle}}>
                            {candidates?.filter(candidate => candidate.status.name === 'FOLLOWUP_INTERVIEW' || candidate.status.name === 'PSYCHOMETRICS' || candidate.status.name === 'REFERENCE_CHECKS').length}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Box sx={{...textStyle}}>
                        <Typography variant="h5" component="h5" style={{color: 'white', alignItems: 'center', justifyContent: 'center'}} >
                            Short-Listed
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

        </Box>
    </Grid>
            <Grid item xs={2}>
                <Box
                    data-testid={"widget-box-offer"}
                    sx={{...commonStyle, backgroundColor: '#338C4C'}}
                    onClick={() => {filterCandidates("JOB_OFFER")}}
                >
                    <Grid container spacing={2} direction={"column"} justifyContent={"center"} alignContent={"stretch"}>
                        <Grid item xs={12}>
                            <Box
                                sx={{...boxStyle}}
                            >
                                <Typography variant="h5" component="h5" style={{...typographyStyle}}>
                                    {candidates?.filter(candidate => candidate.status.name === 'OFFER_LETTER').length}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{...textStyle}}>
                                <Typography variant="h5" component="h5" style={{color: 'white', alignItems: 'center', justifyContent: 'center'}} >
                                    Job-Offer
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                </Box>
            </Grid>
            <Grid item xs={2}>
                <Box
                    data-testid={"widget-box-decline"}
                    sx={{...commonStyle, backgroundColor: '#000000'}}
                    onClick={() => {filterCandidates("DECLINE")}}
                >
                    <Grid container spacing={2} direction={"column"} justifyContent={"center"} alignContent={"stretch"}>
                        <Grid item xs={12}>
                            <Box
                                sx={{...boxStyle}}
                            >
                                <Typography variant="h5" component="h5" style={{...typographyStyle}}>
                                    {candidates?.filter(candidate => candidate.status.name === 'DECLINE').length}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{...textStyle}}>
                                <Typography variant="h5" component="h5" style={{color: 'white', alignItems: 'center', justifyContent: 'center'}} >
                                    Declined
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>


                </Box>
            </Grid>
        </Grid>

)
}


export default Widgets;